import TemplateInfoModal from './TemplateInfoModal';

export default TemplateInfoModal;
